import React  from 'react';
import {
  Box,
  Checkbox,
  Option,
  OptionKey,
} from '@common-fe/common-fe';

interface Props {
  partners: OptionKey[];
  onSelectPartner: (values: OptionKey) => void;
  options: Option[];
}


export const RolesLevelPartnerDropdown: React.FC<Props> = ({  onSelectPartner, partners, options }) => {
  return (
    <Box width="240px" margin={{left: 'l'}}>
      <div>
        {options.map((option) => (
          <Box key={option.key} 
            data-testid={`role-list_level_partner_${option.key}`}
            pad={{ horizontal: 'xs', vertical: 'xxs' }}>
            <Checkbox
              name={option.key as string}
              testId="role-list_level_partner"
              checked={partners.includes(option.key)}
              onChange={() => onSelectPartner(option.key)}>
              {option.title}
            </Checkbox>
          </Box>
        ))}
      </div>
    </Box>
  );
};
export default React.memo(RolesLevelPartnerDropdown);
